export default {
    getFilters: state => state.filter,
    getSubscriptionStatus: state => state.subscriptionStatus,
}